import { useEffect, useState, useCallback } from "react";
import DroneViewer from "./DroneViewer";
import { API_URL } from "../../config";

const WHEP_BASE = "https://dronavispat.senticnel.com:8889";

export default function DroneGuestPage() {
  const [droneId, setDroneId] = useState(null);
  const [error, setError] = useState(null);
  const [ready, setReady] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const guestToken = new URLSearchParams(window.location.search).get("t");

  useEffect(() => {
    if (!guestToken) {
      setError("Enlace no válido");
      return;
    }

    const init = async () => {
      try {
        const resp = await fetch(`${API_URL}drones/guest-stream-token/${guestToken}`);
        if (!resp.ok) {
          const text = await resp.text();
          setError(resp.status === 410 ? "El enlace ha expirado" : text || "Enlace no válido");
          return;
        }
        const data = await resp.json();
        setDroneId(data.droneId);
        setReady(true);
        setShowDialog(true);
      } catch {
        setError("Error al conectar con el servidor");
      }
    };

    init();
  }, [guestToken]);

  const getStreamToken = useCallback(async () => {
    const resp = await fetch(`${API_URL}drones/guest-stream-token/${guestToken}`);
    if (!resp.ok) throw new Error("Enlace expirado o no válido");
    const data = await resp.json();
    return data.streamToken;
  }, [guestToken]);

  if (error) {
    return (
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        height: "100vh", background: "#111", color: "#fff",
        flexDirection: "column", gap: "1rem", fontFamily: "Arial, sans-serif"
      }}>
        <div style={{ fontSize: "3rem" }}>⚠️</div>
        <div style={{ fontSize: "1.2rem" }}>{error}</div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        height: "100vh", background: "#111", color: "#fff",
        fontFamily: "Arial, sans-serif"
      }}>
        Cargando...
      </div>
    );
  }

  return (
    <div style={{ width: "100vw", height: "100vh", background: "black" }}>
      {showDialog && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999
        }}>
          <div style={{
            background: "#fff",
            padding: "2rem",
            borderRadius: "8px",
            maxWidth: "500px",
            textAlign: "center"
          }}>
            <p>
              ATENCIÓN: Al acceder a esta sección el usuario se compromete a no distribuir el contenido de las imágenes mostradas en esta plataforma.
              En caso de incumplimiento, el usuario será responsable de las consecuencias legales derivadas de dicha acción.
            </p>
            <button onClick={() => setShowDialog(false)} style={{ marginTop: "1rem" }}>
              Aceptar
            </button>
          </div>
        </div>
      )}
      {!showDialog && (
        <DroneViewer
          whepUrl={`${WHEP_BASE}/${droneId}/whep`}
          getStreamToken={getStreamToken}
        />
      )}
    </div>
  );
}
